export default __webpack_public_path__ + "static/media/fedex.38a37caa.png";